import { useEffectOnce } from 'react-use'
import { update } from '@/utils/tween'

export function useTweenAnimation() {
  /** @type {number} */
  let id

  function animate() {
    id = requestAnimationFrame(animate)
    update()
  }

  useEffectOnce(() => {
    animate()
    return () => {
      cancelAnimationFrame(id)
    }
  })
}
